import { Link } from "react-router-dom";
import { Instagram, MessageCircle } from "lucide-react";

const links = [
  { label: "Salon Services", href: "#services" },
  { label: "Packages", href: "#packages" },
  { label: "Academy", href: "#academy" },
  { label: "Gallery", href: "#gallery" },
  { label: "About Us", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => (
  <header className="fixed top-0 inset-x-0 z-50 bg-[#FAFAF8]/90 backdrop-blur-xl border-b border-[#E5E7E5] shadow-sm">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between gap-4">
      <a href="#top" className="flex flex-col leading-none" data-testid="nav-brand">
        <span className="font-serif-brand text-2xl font-bold text-[#0A3F2F] tracking-tight">GREEN</span>
        <span className="text-[8px] uppercase tracking-[0.22em] text-[#C5A059] font-bold">Professional Salon &amp; Academy</span>
      </a>
      <nav className="hidden lg:flex items-center gap-6">
        {links.map((l) => (
          <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
            className="text-[13px] uppercase tracking-wide text-[#1C1C1C] hover:text-[#0A3F2F] font-semibold transition-colors">
            {l.label}
          </a>
        ))}
      </nav>
      <div className="flex items-center gap-3">
        <a href="https://wa.me/917056749191" target="_blank" rel="noopener noreferrer" data-testid="nav-whatsapp-link" title="WhatsApp us"
          className="w-9 h-9 rounded-full bg-[#0A3F2F]/10 text-[#0A3F2F] flex items-center justify-center hover:bg-[#0A3F2F] hover:text-white transition-colors">
          <MessageCircle className="w-4 h-4" />
        </a>
        <a href="https://www.instagram.com/green_professional_salon/" target="_blank" rel="noopener noreferrer" data-testid="nav-instagram-link" title="Instagram"
          className="w-9 h-9 rounded-full bg-[#0A3F2F]/10 text-[#0A3F2F] flex items-center justify-center hover:bg-[#0A3F2F] hover:text-white transition-colors">
          <Instagram className="w-4 h-4" />
        </a>
        <Link to="/admin/login" data-testid="nav-admin-link"
          className="hidden sm:block text-[11px] uppercase tracking-wider text-[#5C6A63] hover:text-[#0A3F2F] transition-colors">
          Admin
        </Link>
        <a href="#book" data-testid="nav-book-btn"
          className="btn-lift bg-[#0A3F2F] text-[#FAFAF8] text-xs uppercase tracking-wide font-bold px-5 py-2.5 rounded-full hover:bg-[#0d5540]">
          Book Appointment
        </a>
      </div>
    </div>
  </header>
);
